import { getActiveAreaId, getEquipmentListInArea } from "@/api/area";
import CustomTable from "@/components/customTable/CustomTable";
import { Loader } from "@/components/loader";
import { Box, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";

function EquipmentsInArea() {
  const [loading, setLoading] = useState(false);
  const [equipmentInArea, setEquipmentInArea] = useState([]);
  const [areaId, setAreaId] = useState();

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  const fetchEquipments = useCallback(() => {
    setLoading(true);
    getEquipmentListInArea(areaId)
      .then((x) => setEquipmentInArea(x))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [areaId]);

  useEffect(() => {
    if (areaId) {
      fetchEquipments();
    }
  }, [areaId]);

  const colDefs = useMemo(
    () => [
      {
        headerName: "ردیف",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 100,
      },
      {
        field: "name",
        headerName: "اسم تجهیزات",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.equipmentInfo?.name}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: "healthStatus",
        headerName: "وضعیت",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.equipmentInfo?.healthStatus === "VALID"
                  ? "سالم"
                  : x.data?.equipmentInfo?.healthStatus === "DAMAGED"
                    ? "خراب"
                    : "در حال تعمیر"}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: "name",
        headerName: "شرکت سازنده",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.equipmentInfo?.producer}
              </Typography>
            </Box>
          );
        },
      },
      {
        headerName: "اعتبار گارانتی",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`guaranteeExpireAt_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.equipmentInfo?.guaranteeExpireAt?.split("T", 2)[0]}
              </Typography>
            </Box>
          );
        },
      },
      {
        headerName: "توضیحات",
        width: 200,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`desc_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.equipmentInfo?.description}
              </Typography>
            </Box>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      {loading && <Loader />}
      <CustomTable
        needPagination={false}
        rowData={equipmentInArea}
        columns={colDefs}
      />
    </>
  );
}

export default EquipmentsInArea;
